import { getServiceMapping } from "@/lib/fetch-service-mappings"
import { AppointmentType, AppointmentTypeValues, Service } from "@/types/__generated__/union-types"

const getAllowedAppointmentTypes = (service: Service | null | undefined): AppointmentType[] => {
  const serviceMapping = getServiceMapping().serviceMappings.find((mapping) => mapping.service === service)
  return serviceMapping
    ? [...serviceMapping.allowedAppointmentTypes]
    : AppointmentTypeValues.filter((appointmentType) => !isFlatLength(appointmentType))
}

const isFlatLength = (appointmentType: AppointmentType | null | undefined) =>
  getServiceMapping().appointmentTypeMappings.some(
    (mapping) => mapping.appointmentType === appointmentType && mapping.isFlatLength,
  )

const allowsFollowUp = (service: Service | null | undefined) =>
  getAllowedAppointmentTypes(service).includes("FOLLOW_UP")

const isRestrictedToFlatLength = (service: Service | null | undefined) =>
  getAllowedAppointmentTypes(service).every(isFlatLength)

export { allowsFollowUp, getAllowedAppointmentTypes, isFlatLength, isRestrictedToFlatLength }
